import { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUserDetails } from "../store/Slices/userSlice.js";
import { enrichUserWithAccountType, resolveAccountType } from "../utils/onboarding.js";

const useSyncAccountType = () => {
  const dispatch = useDispatch();
  const { loggedIn, userDetails } = useSelector((state) => state.user);
  const didSync = useRef(false);

  useEffect(() => {
    if (!loggedIn || didSync.current) return;

    const resolved = resolveAccountType(userDetails);
    if (resolved) {
      didSync.current = true;
      if (userDetails?.accountType !== resolved) {
        dispatch(setUserDetails({ ...userDetails, accountType: resolved }));
      }
      return;
    }

    let cancelled = false;
    (async () => {
      const enriched = await enrichUserWithAccountType(userDetails);
      if (cancelled) return;
      didSync.current = true;
      const nextType = resolveAccountType(enriched);
      if (nextType) {
        dispatch(setUserDetails({ ...enriched, accountType: nextType }));
      }
    })();

    return () => {
      cancelled = true;
    };
  }, [loggedIn, userDetails, dispatch]);
};

export default useSyncAccountType;
